import type { NotificationPreferences } from '@court-sync/shared';
import type { ApiResponse } from '@court-sync/shared';
import { apiGet, apiPut } from './apiClient';

export const notificationPreferencesService = {
  async getPreferences(): Promise<ApiResponse<NotificationPreferences>> {
    return apiGet<NotificationPreferences>('/notification-preferences');
  },

  async updatePreferences(prefs: NotificationPreferences): Promise<ApiResponse<null>> {
    return apiPut<null>('/notification-preferences', prefs);
  },
};
